import React from "react";
import ToggleSwitch from "./input-elements/ToggleSwitch";
import { Form } from "react-bootstrap";
import * as Yup from "yup";
import { Grid } from "@mui/material";

const validationSchema = Yup.object().shape({
    referrer_name: Yup.string().when("is_merchant_referral", {
        is: "yes",
        then: Yup.string().required("Referrer Business Name is required"),
        otherwise: Yup.string().notRequired(),
    }),
    referrer_mid: Yup.string().when("is_merchant_referral", {
        is: "yes",
        then: Yup.string().required("Referrer MID is required"),
        otherwise: Yup.string().notRequired(),
    }),
    telemarketer_name: Yup.string().when("is_tm", {
        is: "yes",
        then: Yup.string().required("Telemarketer's name is required"),
        otherwise: Yup.string().notRequired(),
    }),
});

function MerchantReferral({
    setFormDataByKeyValue,
    errors,
    form_data,
    setErrors,
}) {
    const handleOnChange = (e) => {
        try {
            e?.persist();
        } catch (error) {}
        const updatedFormData = {
            ...form_data,
            [e.target.name]: e.target.value,
        };

        setFormDataByKeyValue(e.target.name, e.target.value);
        validationSchema
            .validateAt(e.target.name, updatedFormData)
            .then((e) => {
                // nothing here
            })
            .catch((err) => {
                let validation_errors = errors;
                validation_errors = {
                    ...validation_errors,
                    [e.target.name]: err.errors,
                };
                setErrors(validation_errors);
            });
    };

    const onChangeToggle = (value) => {
        setFormDataByKeyValue("is_merchant_referral", value);
        if (value == "no") {
            setFormDataByKeyValue("referrer_name", "");
            setFormDataByKeyValue("referrer_mid", "");
        }
    };

    const onChangeToggleTM = (value) => {
        setFormDataByKeyValue("is_tm", value);
        if (value == "no") {
            setFormDataByKeyValue("telemarketer_name", "");
        }
    };

    return (
        <div className="merchant-referral">
            <Grid container spacing={2}>
                <Grid item xs={12} sm={6} lg={3}>
                    <p className="sub-heading-lead">Merchant Referral</p>
                    <ToggleSwitch
                        handleChange={(_e, value) => onChangeToggle(value)}
                        value={form_data.is_merchant_referral}
                        options={[
                            { key: "yes", value: "Yes" },
                            { key: "no", value: "No" },
                        ]}
                        name="is_merchant_referral"
                    />
                </Grid>
                <Grid item xs={12} sm={6} lg={3}>
                    <p className="sub-heading-lead">Cold Call</p>
                    <ToggleSwitch
                        handleChange={(_e, value) =>
                            setFormDataByKeyValue("cold_call", value)
                        }
                        value={form_data.cold_call}
                        options={[
                            { key: "yes", value: "Yes" },
                            { key: "no", value: "No" },
                        ]}
                        name="cold_call"
                    />
                </Grid>
                <Grid item xs={12} sm={6} lg={3}>
                    <p className="sub-heading-lead">TM Lead</p>
                    <ToggleSwitch
                        handleChange={(_e, value) =>
                            setFormDataByKeyValue("tm_lead", value)
                        }
                        value={form_data.tm_lead}
                        options={[
                            { key: "yes", value: "Yes" },
                            { key: "no", value: "No" },
                        ]}
                        name="tm_lead"
                    />
                </Grid>
                <Grid item xs={12} sm={6} lg={3}>
                    <p className="sub-heading-lead">TM Name</p>
                    <ToggleSwitch
                        handleChange={(_e, value) => onChangeToggleTM(value)}
                        value={form_data.is_tm}
                        options={[
                            { key: "yes", value: "Yes" },
                            { key: "no", value: "No" },
                        ]}
                        name="is_tm"
                    />
                </Grid>
                {form_data.is_merchant_referral == "yes" && (
                    <Grid item xs={12}>
                        <div className="w-100">
                            <div className="floating-form">
                                <Form.Group size="lg" controlId="referrer_name">
                                    <Form.Control
                                        placeholder="Referrer Business Name"
                                        type="text"
                                        name="referrer_name"
                                        value={form_data.referrer_name}
                                        onChange={handleOnChange}
                                        className="input-control"
                                        readOnly={
                                            form_data.is_merchant_referral ==
                                            "no"
                                        }
                                    />
                                    <Form.Label className="floating-label">
                                        Referrer Business Name
                                    </Form.Label>
                                </Form.Group>
                                {errors?.referrer_name &&
                                    Array.isArray(errors.referrer_name) &&
                                    errors.referrer_name.map((error) => (
                                        <span className="error-message">
                                            {error}
                                        </span>
                                    ))}
                            </div>
                        </div>
                        <div className="w-100">
                            <div className="floating-form">
                                <Form.Group size="lg" controlId="referrer_mid">
                                    <Form.Control
                                        placeholder="Referrer MID"
                                        type="text"
                                        name="referrer_mid"
                                        value={form_data.referrer_mid}
                                        onChange={handleOnChange}
                                        className="input-control"
                                        readOnly={
                                            form_data.is_merchant_referral ==
                                            "no"
                                        }
                                    />
                                    <Form.Label className="floating-label">
                                        Referrer MID
                                    </Form.Label>
                                </Form.Group>
                                {errors?.referrer_mid &&
                                    Array.isArray(errors.referrer_mid) &&
                                    errors.referrer_mid.map((error) => (
                                        <span className="error-message">
                                            {error}
                                        </span>
                                    ))}
                            </div>
                        </div>
                    </Grid>
                )}
                {form_data.is_tm == "yes" && (
                    <Grid xs={12} sx={{ pl: 2 }}>
                        <div className="w-100">
                            <div className="floating-form">
                                <Form.Group
                                    size="lg"
                                    controlId="telemarketer_name"
                                >
                                    <Form.Control
                                        placeholder="Telemarketers name"
                                        type="text"
                                        name="telemarketer_name"
                                        value={form_data.telemarketer_name}
                                        onChange={handleOnChange}
                                        className="input-control"
                                    />
                                    <Form.Label className="floating-label">
                                        Telemarketers name
                                    </Form.Label>
                                </Form.Group>
                                {errors?.telemarketer_name &&
                                    Array.isArray(errors.telemarketer_name) &&
                                    errors.telemarketer_name.map((error) => (
                                        <span className="error-message">
                                            {error}
                                        </span>
                                    ))}
                            </div>
                        </div>
                    </Grid>
                )}
            </Grid>
        </div>
    );
}

export default MerchantReferral;
